import React, {Component} from 'react'
import {compose} from 'recompose'
import WithAjax from './WithAjax'
import WithNotify from './WithNotify';

class ConfirmRequestPopup extends Component {
  constructor() {
    super()

    this.sendRequest = this.sendRequest.bind(this)
  }

  sendRequest() {
    this.props.ajax.put(this.props.url, null, null, () => {
      this.props.onSuccess();
      this.props.notify(this.props.successMessage);
    })
  }

  render() {
    return (
      <div style={{display: 'inline-block'}}>
        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={() => { if (window.confirm(this.props.confirmationQuestion === undefined ? 'Are you sure?' : this.props.confirmationQuestion)) this.sendRequest(); }}>
          {this.props.btnLabel}
        </button>
      </div>
    )
  }
}

export default compose(
  WithNotify,
  WithAjax)(ConfirmRequestPopup)